import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { extractNumber } from '../../../functions/utils/extractNumber';
import { extractUnit } from '../../../functions/utils/extractUnit';
import { CommonInput } from './CommonInput';

const containsOnlyNumbers = (inputString: string) =>
  /^[0-9]+(\.[0-9]+)?$/.test(inputString);

export const UnitInput = ({
  id,
  label,
  placeholder,
  value,
  precision,
  units,
  defaultUnit,
  onChange,
  centered,
  column,
  labelWidth,
}: {
  id: string;
  label?: string;
  placeholder?: string;
  value?: string | number;
  precision?: number;
  units: string[];
  defaultUnit?: string;
  onChange: (value?: string | number) => void;
  centered?: boolean;
  column?: boolean;
  labelWidth?: number;
}) => {
  const [unit, setUnit] = useState<string | null>(null);

  useEffect(() => {
    const extractedUnit = extractUnit(String(value), units);
    const onlyNumbers = containsOnlyNumbers(String(value));

    if (value !== undefined && !onlyNumbers) setUnit(extractedUnit || null);
  }, [value]);

  const computeValue = () => {
    if (value === undefined) return '';

    if (unit) {
      const number = extractNumber(String(value));
      const trimmedZeros = String(Number(number));

      if (number === null) return '';
      if (number !== trimmedZeros) return String(number);
      if (precision !== undefined) return +Number(number).toFixed(precision);
      return String(number);
    }

    return String(value);
  };

  return (
    <CommonInput $centered={centered} $labelWidth={labelWidth} $column={column}>
      {label && <label>{label}</label>}
      <input
        style={{ paddingRight: '28px' }}
        type="text"
        id={id}
        placeholder={placeholder}
        value={computeValue()}
        onChange={(e) => {
          const inputValue = e.currentTarget.value;

          if (containsOnlyNumbers(inputValue)) {
            const number = extractNumber(inputValue);

            onChange(`${number}${unit || defaultUnit || ''}`);
          } else {
            onChange(inputValue || '');
          }
        }}
        onBlur={(e) => {
          const inputValue = e.currentTarget.value;
          const number = extractNumber(inputValue);
          const trimmedZeros = String(Number(number));

          const newValue =
            number === null
              ? inputValue
              : unit
              ? `${trimmedZeros}${unit || defaultUnit}`
              : !isNaN(Number(number))
              ? Number(number)
              : undefined;

          onChange(newValue === '' ? undefined : newValue);
        }}
      ></input>
      <Unit>{unit || defaultUnit}</Unit>
    </CommonInput>
  );
};

const Unit = styled.div`
  pointer-events: none;
  position: absolute;
  bottom: 8px;
  right: 10px;

  display: flex;
  align-items: center;

  color: var(--text-color-secondary);
  font-size: 10px;
`;
